<template>
	<div class="wrap">
		<div class="main">
			<div class="neibox">
				<div class="shaibox">
					<el-input style="width: 200px;margin-right: 15px;" v-model="input" placeholder="请输入内容"></el-input>
					<el-select v-model="value" placeholder="请选择" @change="qieChange">
						<el-option v-for="item in options" :key="item.id" :label="item.ltitle" :value="item.id">
						</el-option>
					</el-select>
					<el-button type="primary" style="margin-left: 15px;" @click="getCompositeList">搜索</el-button>
				</div>

				<el-table :data="tableData" style="width: 100%">
					<el-table-column prop="id" label="ID" width="180">
					</el-table-column>
					<el-table-column prop="title" label="产品名称">
					</el-table-column>
					<el-table-column prop="create_time" label="开通日期">
					</el-table-column>
					<el-table-column prop="end_time" label="到期日期">
					</el-table-column>
					<el-table-column prop="repay_money" label="产品价格">
						<template slot-scope="scope">
							<div v-if="scope.row.repay_money">{{scope.row.repay_money}}元/年</div>
							<div v-else>{{scope.row.money}}</div>
						</template>
					</el-table-column>

					<el-table-column prop="status_text" label="产品状态">
					</el-table-column>
					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button size="mini" type="primary"
								@click="handleDelete(scope.$index, scope.row.id)">续费</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="fenye">
					<FenPage :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getCompositeList" />
				</div>

			</div>

			<el-dialog title="续费" :visible.sync="dialogVisible" width="1100px" :before-close="handleClose">
				<div class="xubox">
					<div class="xutitle">
						续费产品
					</div>
					<div class="biao">
						<div class="biaotop">
							基本信息
						</div>
						<div class="chantui">
							<div class="chanli">
								<div class="chantxt">产品类型：{{info.category_title}}</div>
							</div>
							<div class="chanli">
								<div class="chantxt">产品名称：{{info.product_title}}</div>
							</div>
						</div>
						<div class="kaibox">
							<div class="kaili">
								开通时间： {{info.create_time}}
							</div>
							<div class="kaili">
								到期时间：
								<span>{{info.end_time}}</span>
							</div>
							<div class="kaili">
								续费后到期时间：
								<span>{{endTime}}</span>
							</div>
						</div>
					</div>

					<div class="zebox">
						<div class="zeli">
							<div class="zetxt">续费时长</div>
							<el-select v-model="timevalue" placeholder="请选择" @change="qievalue">
								<el-option v-for="item in timeSelect" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</div>
						<div class="zeli">
							<div class="zetxt">应付金额</div>

							<div
								style="width: 195px;padding: 0 10px;border: 1px solid #dddddd;border-radius: 5px;height: 38px;line-height: 38px;font-size: 14px;color: #333333;">
								{{yinginput}}</div>
						</div>
					</div>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button type="primary" @click="goTopay">确认支付</el-button>
					<el-button @click="handleClose">返回</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import FenPage from '../../components/FenPage.vue'
	export default {
		components:{
			FenPage
		},
		data() {
			return {
				// 搜索
				input: '',
				options: [],
				value: '',
				// 弹框选择
				timevalue: '',

				valuea: '',
				yinginput: '',
				// 表格
				tableData: [],
				category_id: '',
				// 分页
				page_data: {
					limit: 20,
					page: 1,
					total:20,
				},
				// 弹框
				dialogVisible: false,
				// 弹框数据
				info: {},
				endTime: '',
				id: '',
				timeSelect: [],
				payid: ''

			}
		},
		watch: {
			timevalue(value) {
				this.timeSelect.forEach((item, index) => {
					if (value === item.id) {
						this.endTime = item.time
						this.yinginput = item.money
						this.payid = item.id
					}
				})
			}
		},
		created() {
			this.getCategory()
			this.getCompositeList()
		},
		methods: {
			// 请求分类
			async getCategory() {
				const res = await this.$api.getCategory();
				this.options = res.data
			},
			// 选择分类
			qieChange(e) {
				console.log(e)
				this.category_id = e
			},
			// 请求列表
			async getCompositeList() {
				
				this.tableData = []
				let param = {limit:this.page_data.limit,page:this.page_data.page}
				Object.assign(param, {
					name: this.input,
					category_id: this.category_id
				})
				console.log(param,'222')
				const res = await this.$api.getCompositeList(param);
				this.tableData = res.data.data
				this.page_data.total = res.data.total
			},
			// 分页
			
			// 续费时长
			qievalue(e) {
				console.log(this.timevalue, '3433333')
				this.yinginput = e.money
				this.endTime = e.time
				console.log(e, '22222')
			},
			// 续费数据
			async getRepay(id) {
				const res = await this.$api.getRepay({
					id: id
				});
				this.info = res.data
				this.timeSelect = res.data.option
			},
			
			// 续费
			async goTopay() {
				const res = await this.$api.getgoTopay({
					id: this.id,
					time_id: this.payid
				});
				if(res.code == 1){
					alert('续费成功')
					this.dialogVisible = false
					this.yinginput = ''
					this.tableData = []
					this.getCompositeList()
				}
			},
			// 表格续费按钮
			handleDelete(index, row) {
				console.log(index, row);
				this.id = row
				this.getRepay(row)
				this.dialogVisible = true
			},
			
			// 当前页
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			// 弹框
			handleClose(done) {
				this.dialogVisible = false
				this.yinginput = ''
			},

		},

	}
</script>

<style>
	.neibox {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 5px;
	}



	.fenye {
		display: flex;
		align-items: center;
		justify-content: center;
		padding-top: 20px;
	}

	.xutitle {
		font-size: 22px;
		color: #333333;
		border-bottom: 1px solid #dddddd;
		padding-bottom: 10px;
		margin-bottom: 15px;
	}

	.biao {
		border: 1px solid #dddddd;
	}

	.biaotop {
		padding: 0 20px;
		background-color: #f1f1f1;
		border-bottom: 1px solid #dddddd;
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		color: #333333;
	}

	.chantui {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 50px;
		border-bottom: 1px solid #dddddd;
		height: 50px;
	}

	.chanli {
		height: 50px;
		line-height: 50px;
		width: 50%;
		border-right: 1px solid #dddddd;
	}

	.chanli:last-child {
		border: none;
	}

	.chantxt {
		padding: 0 20px;
		font-size: 14px;
		color: #333333;
	}

	.kaibox {
		display: flex;
		align-items: center;
		height: 50px;
		padding: 0 20px;
	}

	.kaili {
		font-size: 14px;
		color: #333333;
		padding-right: 100px;
	}

	.kaili span {
		color: #ff0000;
		font-size: 14px;
	}

	.zebox {
		padding: 20px 20px 0;
	}

	.zetxt {
		font-size: 14px;
		color: #333333;
		padding-right: 10px;
	}

	.zeli {
		display: flex;
		align-items: center;
		padding-bottom: 10px;
	}

	.el-dialog__header {
		background-color: #f8f8f8 !important;
	}

	.el-dialog__body {
		background-color: #f2f2f2 !important;
	}

	.el-dialog__footer {
		background-color: #f2f2f2 !important;
	}

	.xubox {
		background-color: #ffffff;
		padding: 15px;
	}
</style>